import { PhysioLayout } from "@/components/layout/physio-layout";
import { EventsList } from "@/components/events/events-list";

export default function PhysioEvents() {
  return (
    <PhysioLayout title="Events">
      <EventsList
        intro="CSP events, ACPR rheumatology study days, EULAR PARE sessions, NICE MSK updates, and more — UK physiotherapy CPD and HCPC revalidation-relevant events in one place."
        accentBg="bg-cyan-100"
        accentIcon="text-cyan-700"
        accentLink="text-cyan-600 hover:text-cyan-800"
      />
    </PhysioLayout>
  );
}
